import { forwardRef, type InputHTMLAttributes } from "react";

import { cn } from "../lib/utils";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, type = "text", ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      aria-invalid={invalid || undefined}
      className={cn(
        "h-10 w-full rounded-[var(--radius-md)] px-3.5 text-sm",
        "bg-[oklch(100%_0_0_/_0.6)] backdrop-blur-[var(--blur-glass-light)]",
        // Phase J: border alpha bumped 0.10 → 0.30 so non-text
        // contrast clears WCAG 1.4.11 (3:1 against the worst-case
        // glass-composite background). The prior 0.10 produced a
        // border that effectively vanished on the cockpit's
        // alpha-0.5 glass shell.
        "border border-[oklch(0%_0_0_/_0.30)] text-[var(--color-text-strong)]",
        "placeholder:text-[var(--color-text-faint)]",
        "transition-colors",
        "focus-visible:outline-none focus-visible:border-[var(--color-brand-soft)]",
        "focus-visible:ring-2 focus-visible:ring-[var(--color-brand-soft)]/30",
        "disabled:cursor-not-allowed disabled:opacity-50",
        invalid && "border-[var(--color-accent-red)] focus-visible:ring-[var(--color-accent-red)]/30",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
